import React from "react";
import { registerTeaserWebComponent, renderServerSide, ITeaserProps } from "@talkfurther/elements";

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "further-teaser": any;
    }
  }
}

export class Teaser extends React.Component {
  constructor(props: ITeaserProps) {
    super(props);
    this.state = { isClient: false };
  }

  componentDidMount() {
    // componentDidMount only runs in the client,
    // so when it runs, we know for sure it's client-side
    this.setState({ isClient: true });
    registerTeaserWebComponent();
  }

  render() {
    const props = this.props as ITeaserProps;
    const { isClient } = this.state as any;
    const html = isClient ? "" : renderServerSide(props);

    return (
      <further-teaser
        suppressHydrationWarning={true}
        dangerouslySetInnerHTML={{ __html: html }}
        vsa-instance={props.vsaInstance}
        title={props.title}
        subtitle={props.subtitle}
        options={JSON.stringify(props.options)}
        show-recent-tour-inquiries={props.showRecentTourInquiries}
        theme={JSON.stringify(props.theme || {})}
        custom-css={props.customCss}
      ></further-teaser>
    );
  }
}

export default Teaser;
